import { isAuthenticated } from "@/routers/router-guardians"
import store from "@/store"

const routes = [
  {
    path: "/encounter-layout",
    name: "encounter-layout",
    component: () => {
      if (store.getters["me/allowNewChartingUiFeatures"]) {
        return import("@/layouts/encounter-layout/EncounterLayout.vue")
      } else {
        return import("@/layouts/patient-layout/PatientLayout.vue")
      }
    },
    props: (route) => ({ encounterId: route.params.encounterId }),
    children: [
      {
        path: "/dashboard/encounters/:encounterId",
        name: "encounter",
        component: () => {
          if (store.getters["me/allowNewChartingUiFeatures"]) {
            return import("@/modules/charting/pages/encounter/Encounter.vue")
          } else {
            return import("@/modules/charting-deprecated/pages/encounter/Encounter.vue")
          }
        },
        props: (route) => ({
          encounterId: route.params.encounterId,
          step: route.params.step
        }),
        beforeEnter(to, from, next) {
          isAuthenticated(to, from, next)
        }
      }
    ]
  }
]

export default routes
